import { Flex } from "@minervaproject/fds";
import ReactModal from "react-modal";

import { IconNotFocused } from "./icon_not_focused";
import { IconTalkTimeAvgBubbles } from "./icon_talk_time_avg_bubbles";
import { IconTalkTimeAvgFace } from "./icon_talk_time_avg_face";
import { IconTalkTimeHighBubbles } from "./icon_talk_time_high_bubbles";
import { IconTalkTimeHighFace } from "./icon_talk_time_high_face";
import { IconTalkTimeLowBubbles } from "./icon_talk_time_low_bubbles";
import { IconTalkTimeLowFace } from "./icon_talk_time_low_face";

import "./talk_time_legend.scss";

function TalkTimeLegend() {
  return (
    <>
      <div className="flex">
        <div className="talk-time__card bg-orange mr5">
          <div className="talk-time-low-bubbles">
            <IconTalkTimeLowBubbles />
          </div>
          <div className="talk-time-low-face">
            <IconTalkTimeLowFace />
          </div>
          <div className="mt5 center">Less than average Talk Time</div>
        </div>

        <div className="talk-time__card bg-green mr5">
          <div className="talk-time-avg-bubbles">
            <IconTalkTimeAvgBubbles />
          </div>
          <div className="talk-time-avg-face">
            <IconTalkTimeAvgFace />
          </div>
          <div className="mt5 center">Average amount of Talk Time</div>
        </div>

        <div className="talk-time__card bg-blue">
          <div className="talk-time-high-bubbles">
            <IconTalkTimeHighBubbles />
          </div>
          <div className="talk-time-high-face">
            <IconTalkTimeHighFace />
          </div>
          <div className="mt5 center">Greater than average Talk Time</div>
        </div>
      </div>

      <div className="flex items-center justify-center mt7">
        <div className="not-focused mr3">
          <IconNotFocused />
        </div>
        <div>Participant doesn&apos;t have classroom in focus</div>
      </div>
    </>
  );
}

function TalkTimeLegendModal() {
  ReactModal.setAppElement("#root");

  const containerId = "#stage-container";

  return (
    <ReactModal
      data-testid="talk-time-legend-modal"
      className="bg-transparent p7 absolute-center outline-none"
      overlayClassName="default-modal-overlay"
      parentSelector={() => document.querySelector(containerId)!}
      isOpen
    >
      <Flex auto className="talk-time-legend">
        <div>
          <TalkTimeLegend />
        </div>
      </Flex>
    </ReactModal>
  );
}

export { TalkTimeLegend, TalkTimeLegendModal };
